import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useConvertToMobile } from '../utils/useConvertToMobile';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { FeaturedIcon } from '../FeaturedIcon';
import Divider from '@mui/material/Divider';
import { CloseButton } from '../common/CloseButton';
import { Badge } from '../Badge';
import { HelpIconWithTooltip } from '../common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var MOBILE_PADDING = '16px';
var DESKTOP_PADDING = '24px';
export function DialogHeader(props) {
  var _props$badge = props.badge,
    badge = _props$badge === void 0 ? false : _props$badge,
    badgeColor = props.badgeColor,
    badgeDataAttributes = props.badgeDataAttributes,
    badgeLabel = props.badgeLabel,
    _props$divider = props.divider,
    divider = _props$divider === void 0 ? true : _props$divider,
    _props$helpIcon = props.helpIcon,
    helpIcon = _props$helpIcon === void 0 ? true : _props$helpIcon,
    iconLeadingColor = props.iconLeadingColor,
    iconLeadingIcon = props.iconLeadingIcon,
    iconLeadingSize = props.iconLeadingSize,
    iconLeadingTheme = props.iconLeadingTheme,
    mobileBreakpoint = props.mobileBreakpoint,
    mobileBreakpointContainerRef = props.mobileBreakpointContainerRef,
    onClose = props.onClose,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? true : _props$showCloseButto,
    _props$showFeaturedIc = props.showFeaturedIcon,
    showFeaturedIcon = _props$showFeaturedIc === void 0 ? true : _props$showFeaturedIc,
    supportingText = props.supportingText,
    sx = props.sx,
    text = props.text,
    tooltipDescription = props.tooltipDescription,
    tooltipLabel = props.tooltipLabel,
    tooltipPlacement = props.tooltipPlacement,
    tooltipVariant = props.tooltipVariant,
    _props$type = props.type,
    type = _props$type === void 0 ? 'stack-left-aligned' : _props$type,
    _props$withPaddingBot = props.withPaddingBottom,
    withPaddingBottom = _props$withPaddingBot === void 0 ? true : _props$withPaddingBot;
  var theme = useTheme();
  var isMobile = useConvertToMobile(mobileBreakpoint, mobileBreakpointContainerRef);
  var flexDirection = !showFeaturedIcon ? 'row-reverse' : 'column';
  flexDirection = type === 'horizontal-left-aligned' && !isMobile ? 'row' : 'column';
  var padding = isMobile ? MOBILE_PADDING : DESKTOP_PADDING;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: _extends({
        padding: "".concat(padding, " ").concat(padding, " 0px ").concat(padding),
        textAlign: type === 'center-aligned' ? 'center' : 'unset'
      }, sx),
      "data-element": "Box",
      "data-source-file": "DialogHeader.tsx",
      children: /*#__PURE__*/_jsxs(Stack, {
        display: type === 'horizontal-left-aligned' ? 'flex' : 'block',
        flexDirection: "row",
        justifyContent: type === 'horizontal-left-aligned' ? 'space-between' : 'center',
        sx: {
          position: 'relative'
        },
        "data-element": "Stack",
        "data-source-file": "DialogHeader.tsx",
        children: [showCloseButton && /*#__PURE__*/_jsx(Box, {
          sx: {
            height: '40px',
            position: 'absolute',
            right: 0,
            top: 0
          },
          children: /*#__PURE__*/_jsx(CloseButton, {
            height: "40px",
            onClose: onClose,
            size: 24,
            width: "40px"
          })
        }), /*#__PURE__*/_jsxs(Stack, {
          direction: flexDirection,
          "data-element": "Stack",
          "data-source-file": "DialogHeader.tsx",
          children: [showFeaturedIcon && iconLeadingIcon && /*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              justifyContent: type === 'center-aligned' ? 'center' : 'start',
              marginBottom: '12px',
              marginRight: !isMobile && type !== 'center-aligned' ? '16px' : 0
            },
            children: /*#__PURE__*/_jsx(FeaturedIcon, {
              Icon: iconLeadingIcon,
              color: iconLeadingColor,
              iconTheme: iconLeadingTheme,
              size: iconLeadingSize
            })
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              marginBottom: withPaddingBottom ? '20px' : 0
            },
            "data-element": "Box",
            "data-source-file": "DialogHeader.tsx",
            children: /*#__PURE__*/_jsxs(Stack, {
              alignItems: type === 'center-aligned' ? 'center' : 'unset',
              "data-element": "Stack",
              "data-source-file": "DialogHeader.tsx",
              children: [/*#__PURE__*/_jsxs(Stack, {
                alignItems: "center",
                direction: "row",
                marginTop: !supportingText && type === 'horizontal-left-aligned' && showFeaturedIcon ? '5px' : '0px',
                spacing: 2,
                "data-element": "Stack",
                "data-source-file": "DialogHeader.tsx",
                children: [/*#__PURE__*/_jsx(Typography, {
                  sx: {
                    color: theme.palette.gray[900],
                    marginBottom: '4px'
                  },
                  variant: "text-lg-semibold",
                  "data-element": "Typography",
                  "data-source-file": "DialogHeader.tsx",
                  children: text
                }), helpIcon && /*#__PURE__*/_jsx(HelpIconWithTooltip, {
                  tooltipDescription: tooltipDescription,
                  tooltipLabel: tooltipLabel,
                  tooltipPlacement: tooltipPlacement,
                  tooltipVariant: tooltipVariant
                }), badge && /*#__PURE__*/_jsx(Badge, {
                  color: badgeColor,
                  dataAttributes: badgeDataAttributes,
                  label: badgeLabel,
                  size: "sm",
                  type: "pillColor"
                })]
              }), /*#__PURE__*/_jsx(Typography, {
                sx: {
                  color: theme.palette.gray[600]
                },
                variant: "text-sm-regular",
                "data-element": "Typography",
                "data-source-file": "DialogHeader.tsx",
                children: supportingText
              })]
            })
          })]
        })]
      })
    }), divider && /*#__PURE__*/_jsx(Divider, {
      sx: {
        borderColor: theme.palette.gray[200],
        height: '1px'
      }
    })]
  });
}